export default __webpack_public_path__ + "static/media/Snd_CZ.95f7c3e8.mp3";